export const GET_USER = "GET_USER"
export const LOGOUT = "LOGOUT"